<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;" @click="goback()"></i>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('aboutUs')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="about-main">
        <div class="about-title" v-if="common.isMobile() === false">About</div>
        <div class="about-content">
          <span>At Roompai, our mission is to provide travelers with a refreshing and comfortable trip through our exceptional hotel products. We strive to create an experience that not only meets your needs but also ignites your passion and inspires you along the way. Our commitment to excellence represents the essence of PAI (passion and inspiration), , and we hope that every journey with Roompai leaves you with unforgettable memories and a newfound sense of adventure.</span>
          <span>Our website offers a diverse range of selective accommodations that go beyond the ordinary. With an extensive network of trusted partners worldwide, we curate a collection of hotels, resorts, and boutique properties that reflect the essence of your chosen destination.</span>
          <span>Booking with Roompai is effortless. Customer satisfaction is our top priority. Our dedicated team is available 24/7 in English to assist you, ensuring transparent pricing, secure bookings, and reliable support throughout your stay. Experience the world with Roompai and unlock unforgettable moments. Start your journey today and let us be your trusted companion in exploring the world, one remarkable stay at a time.</span>
        </div>
        <div class="about-title">Value</div>
        <div class="about-content">
          <span>If life is a book, travel makes you read more. Everyone deserves a little getaway from the hustle and bustle, for which we would like to provide you with a comfortable place to make your trip easy and smooth. </span>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'aboutUs',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      source: 'roompai',
      conver: ''
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
    let conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  methods: {
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.about-main{height:840px;margin:20px auto;color: rgba(0, 0, 0, 0.6470588235294118);}
.about-title{height:60px;font-weight: 650;font-size: 18px;line-height: 60px;}
.about-content span{ font-weight: 400;font-size: 14px;line-height: 22px; display:block; margin-bottom:20px;}
@media screen and (min-width: 1001px) {
.about-main{width:1100px;}
}
@media screen and (max-width: 1000px) {
.about-main{width:90%;}
}
</style>



// WEBPACK FOOTER //
// src/components/question/aboutUs.vue